import styled from 'styled-components';
import { ArrowLogo } from '@applicationKYC/FarmersQuestionnaire/assets/images';

export const BackButtonStyle = styled.div`
  button {
    background-color: #e6e6e6;
    color: black;
    border: none;
    width: 40px;
    padding: 0;
    margin-bottom: 10px;

    &:hover {
      background-color: #d9d9d9;
      color: black;
      border: none;
    }
  }
`;

export const ArrowLogoStyle = styled(ArrowLogo)`
  transform: rotate(180deg);
`;
